module.exports = __webpack_public_path__ + "img/model_space_logo.06731513.png";